export function removeCompanyNameSuffix (name: string) {
    return name.toUpperCase().replace(/\s(OYJ|OY|LTD|RY|AB)\b/g, '');
}
